import type { RouteObject } from 'react-router-dom';
import { RoleGuard } from '@/shared/guards/RoleGuard';
import { CONTENT_ROLES } from '@/shared/guards/roles';
import { ContentPage } from './pages/ContentPage';
import { ContentItemDetailPage } from './pages/ContentItemDetailPage';
import { SubjectViewDetailPage } from './pages/SubjectViewDetailPage';
import { SubjectGraphPage } from './pages/SubjectGraphPage';
import { ExamPreviewPage } from './pages/ExamPreviewPage';
import { ExamImportPage } from './pages/ExamImportPage';

/**
 * Sub-árvore de rotas do módulo Conteúdo. Gateada por `CONTENT_ROLES` — espelha
 * o `@Roles('adminDashboard.administrator')` do `ContentAdminReadController`.
 * Dentro do módulo só a taxonomia tem gate próprio (`useCanWriteSubjects`,
 * espelhando o `StrictRoles` do backend). É só UX; o back enforce em
 * `/admin/content/*`.
 */
export const contentRoutes: RouteObject[] = [
  {
    element: <RoleGuard roles={CONTENT_ROLES} />,
    children: [
      {
        path: 'content',
        children: [
          // `:tab?` opcional: a aba vive na URL (compartilhável, sobrevive a
          // refresh). Rotas estáticas (`graph`) têm precedência sobre o param.
          { path: ':tab?', element: <ContentPage /> },
          { path: 'graph', element: <SubjectGraphPage /> },
          { path: 'exams/import', element: <ExamImportPage /> },
          { path: 'exams/:examId', element: <ExamPreviewPage /> },
          { path: 'items/:contentId', element: <ContentItemDetailPage /> },
          { path: 'views/:viewId', element: <SubjectViewDetailPage /> },
        ],
      },
    ],
  },
];
